const render = {
  listLabel1: 'Área General',
  listLabel2: 'Tablas',
  listLabel3: 'Área del Usuario',
  listLabel4: 'Parámetros',
  listLabel5: 'Sistema'
}

export default render;
